import React from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Layout from "../../../components/layout/Layout";
import ChangePassword from "./personal-information/ChangePassword";
import PersonalInformation from "./personal-information/PersonalData";
import BankInformation from "./personal-information/BankInformation";
import { LOCALES } from "common/constants";

const SettingsView = () => {
  const navigate = useNavigate();
  let language = localStorage.getItem("i18nextLng");

  return (
    <Layout className="p-4 bg_change" showSidebar bgcolor>
      <Routes>
        <Route
          exact
          path={
            language === LOCALES.EN_US ? "personal-information" : "personlig-information"
          }
          element={<PersonalInformation />}
        />
        <Route
          exact
          path={language === LOCALES.EN_US ? "bank-information" : "bankinformation"}
          element={<BankInformation />}
        />

        <Route
          exact
          path={language === LOCALES.EN_US ? "change-password" : "andra-losenord"}
          element={<ChangePassword />}
        />
        <Route
          path="*"
          element={
            <Navigate
              to={
                language === LOCALES.EN_US
                  ? `/dashboard/settings/personal-information?lang=${LOCALES.EN_US}`
                  : `/instrumentbrada/installningar/personlig-information?lang=${LOCALES.SV_SE}`
              }
            />
          }
        />
        <Route path="privacy-policy" component={navigate} />
      </Routes>
    </Layout>
  );
};

export default SettingsView;
